import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';
import ContentItem6 from 'presentations/views/components/molecules/ServiceContentItem6';
import { useMemo } from 'react';

interface Props {
  title?: string;
  subTitle?: string;
}

export default function Component(props: Props) {
  const t = translateInComponent(translations);
  const items = useMemo(() => {
    const data = [];
    for (let i = 0; i < 4; i++) {
      data.push({
        title: t(`itemTitle.${i}`),
        description: t(`itemDescription.${i}`),
        imageUrl: `pages/top/202206/slide/1-${i + 1}.png`,
      });
    }
    return data;
  }, []);
  return (
    <ContentItem6
      items={items}
      title={props.title || t('title')}
      subTitle={props.subTitle || t('sub title')}
      description={t('description')}
      imageWidth={858}
      imageHeight={620}
    />
  );
}
